import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@/components/shared/PageLoader';
import { requireAlfieCapability } from '@/api/alfie-plan';

const Alfie = lazy(() => import('@/pages/Alfie'));

type AlfieSearch = {
  query?: string;
  threadId?: string;
};

export const Route = createFileRoute('/alfie/')({
  // Free plans don't include Alfie chat — send them to upgrade.
  beforeLoad: ({ context: { queryClient } }) =>
    requireAlfieCapability(queryClient, 'alfie_chat'),
  component: () => (
    <Suspense fallback={<PageLoader dark={false} />}>
      <Alfie />
    </Suspense>
  ),
  validateSearch: (search: Record<string, unknown>): AlfieSearch => {
    return {
      query: typeof search.query === 'string' ? search.query : undefined,
      threadId: typeof search.threadId === 'string' ? search.threadId : undefined,
    };
  },
});
